<template>
  <CardItem :show-top-bar="false">
    <div class="flex flex-grow justify-center items-center">
      <TextTitle>
        <template #icon>
          <ik-image
              v-if="showCustomImage"
              :src="thankyouScreen.image.src | parseImgUrl"
              style="max-width: 50px; height: 50px;"
              class="w-full object-cover select-none pointer-events-none"
              alt="Image"
          />
          <a-icon
              v-else
              :type="iconName"
          />
        </template>
        {{ title }}
      </TextTitle>
    </div>
    <template #button>
      <a
          v-if="showButton"
          :href="button.link"
          target="_parent">
        <a-button
            type="primary"
            class="btn-action-primary"
            :style="[buttonBgColor, buttonTextColor]">
          {{ button.text }}
        </a-button>
      </a>
    </template>
  </CardItem>
</template>

<script>
import {mapGetters} from "vuex";
import {parseImgUrl} from "../../helpers/fns";
import themeMixin from "../../mixins/theme.mixin";
import CardItem from "../CardItem";
import TextTitle from "../TextTitle";

export default {
  name: "ScreenError",
  components: {CardItem, TextTitle},
  mixins: [themeMixin],
  filters: {parseImgUrl},
  mounted() {
    this.init();
    document.title = this.title;
  },
  data() {
    return {
      title: "",
      iconName: "",
    }
  },
  computed: {
    ...mapGetters(["error"]),
    thankyouScreen() {
      return this.error?.data?.thankyouScreen;
    },
    button() {
      return this.thankyouScreen?.button || {};
    },
    showButton() {
      return this.button.isActive && this.button.link && this.button.text;
    },
    showCustomImage() {
      return this.error.type === "RESPONDED" &&
          this.thankyouScreen?.image?.type === 'custom' &&
          this.thankyouScreen?.image?.src;
    },
  },
  methods: {
    init() {
      const {code, type, data} = this.error;
      const {translations} = data || {};

      if (code === 404) {
        this.title = 'Survey not found';
        this.iconName = 'close-circle';
        return;
      }

      if (!type) {
        this.title = 'Could not load a survey';
        this.iconName = 'frown';
        return;
      }

      if (type === 'NOT_AVAILABLE') {
        this.title = translations?.surveyMessages?.titleSurveyPaused?.value || translations?.surveyMessages?.titleSurveyPaused?.defaultValue || "";
        this.iconName = 'pause-circle';
      } else if (type === 'RESPONDED') {
        this.title = translations.surveyMessages?.titleSurveyTaken?.value || translations.surveyMessages?.titleSurveyTaken?.defaultValue || "";
        this.iconName = 'check-circle';
      }
    }
  }
}
</script>

<style scoped>

</style>
